import { useState, useEffect } from 'react'
import { NewsItem } from '../types'

// Realistic fallback data in case API fails or for demo purposes
const FALLBACK_NEWS: NewsItem[] = [
  {
    id: '1',
    title: 'OpenAI announces GPT-5 development roadmap with focus on reasoning',
    source: 'TechCrunch',
    time: '2h ago',
    url: '#',
    category: 'LLM',
  },
  {
    id: '2',
    title:
      'Midjourney V7 alpha testing begins: Photorealism reaches new heights',
    source: 'The Verge',
    time: '4h ago',
    url: '#',
    category: 'Image Gen',
  },
  {
    id: '3',
    title: 'Google DeepMind solves 50-year-old geometry problem',
    source: 'Nature',
    time: '6h ago',
    url: '#',
    category: 'Research',
  },
  {
    id: '4',
    title: 'Stability AI releases Stable Audio 2.0 with full track generation',
    source: 'VentureBeat',
    time: '8h ago',
    url: '#',
    category: 'Audio',
  },
  {
    id: '5',
    title: 'NVIDIA unveils new Blackwell B200 GPU for massive AI models',
    source: 'Ars Technica',
    time: '12h ago',
    url: '#',
    category: 'Hardware',
  },
  {
    id: '6',
    title: 'Apple integrates generative AI into Xcode for faster development',
    source: '9to5Mac',
    time: '1d ago',
    url: '#',
    category: 'Dev',
  },
]

export function useAINews() {
  const [news, setNews] = useState<NewsItem[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // Simulating a fetch for the demo to ensure high quality data
    // In a real app, this would fetch from NewsAPI or similar
    const fetchNews = async () => {
      try {
        await new Promise((resolve) => setTimeout(resolve, 1500)) // Fake delay
        setNews(FALLBACK_NEWS)
        setLoading(false)
      } catch (error) {
        console.error('Failed to fetch news', error)
        setNews(FALLBACK_NEWS)
        setLoading(false)
      }
    }

    fetchNews()
  }, [])

  return { news, loading }
}
